<ng-container *ngIf="items && items.length > 0 && (size$ | async) as size">
  <h2 *ngIf="title">{{ title }}</h2>

  <div class="carousel-panel" [ngClass]="'size-' + size">
    <ng-container *cxFeature="'a11yFocusableCarouselControls'">
      <button
        *ngIf="size < items.length"
        class="previous"
        (click)="
          $event.stopPropagation();
          activeSlide === 0 ? null : (activeSlide = activeSlide - size)
        "
        [attr.aria-disabled]="activeSlide === 0"
        [attr.aria-label]="'carousel.previousSlide' | cxTranslate"
        [attr.title]="'carousel.previousSlide' | cxTranslate"
        (keydown.arrowleft)="shareEvent($any($event))"
        (keydown.arrowright)="shareEvent($any($event))"
        (keydown.arrowup)="shareEvent($any($event))"
        (keydown.arrowdown)="shareEvent($any($event))"
      >
        <cx-icon [type]="previousIcon"></cx-icon>
      </button>
    </ng-container>
    <ng-container *cxFeature="'!a11yFocusableCarouselControls'">
      <button
        *ngIf="size < items.length"
        class="previous"
        (click)="$event.stopPropagation(); activeSlide = activeSlide - size"
        [disabled]="activeSlide === 0"
        [attr.aria-label]="'carousel.previousSlide' | cxTranslate"
        [attr.title]="'carousel.previousSlide' | cxTranslate"
      >
        <cx-icon [type]="previousIcon"></cx-icon>
      </button>
    </ng-container>

    <div class="slides">
      <ng-container *ngFor="let _ of items; let i = index">
        <div
          class="slide"
          *ngIf="i % size === 0"
          [class.active]="i === activeSlide"
        >
          <ng-container
            *ngFor="let item of items | slice: i : i + size; let j = index"
          >
            <div
              *ngIf="item | async as data"
              class="item"
              [class.active]="i === activeSlide"
              (keydown)="onItemKeydown($event, size)"
            >
              <ng-container
                *ngTemplateOutlet="template; context: { item: data }"
              ></ng-container>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <!-- TODO: (CXSPA-6904) - Remove feature flag next major release -->
    <ng-container *cxFeature="'a11yFocusableCarouselControls'">
      <button
        *ngIf="size < items.length"
        class="next"
        (click)="
          $event.stopPropagation();
          activeSlide > items.length - size - 1
            ? null
            : (activeSlide = activeSlide + size)
        "
        [attr.aria-disabled]="activeSlide > items.length - size - 1"
        [attr.aria-label]="'carousel.nextSlide' | cxTranslate"
        [attr.title]="'carousel.nextSlide' | cxTranslate"
        (keydown.arrowleft)="shareEvent($any($event))"
        (keydown.arrowright)="shareEvent($any($event))"
        (keydown.arrowup)="shareEvent($any($event))"
        (keydown.arrowdown)="shareEvent($any($event))"
      >
        <cx-icon [type]="nextIcon"></cx-icon>
      </button>
    </ng-container>
    <ng-container *cxFeature="'!a11yFocusableCarouselControls'">
      <button
        *ngIf="size < items.length"
        class="next"
        (click)="$event.stopPropagation(); activeSlide = activeSlide + size"
        tabindex="-1"
        [disabled]="activeSlide > items.length - size - 1"
        [attr.aria-label]="'carousel.nextSlide' | cxTranslate"
        [attr.title]="'carousel.nextSlide' | cxTranslate"
      >
        <cx-icon [type]="nextIcon"></cx-icon>
      </button>
    </ng-container>
  </div>

  <div
    *ngIf="!hideIndicators && size < items.length"
    role="tablist"
    class="indicators"
  >
    <ng-container *ngFor="let _ of items; let i = index">
      <!-- TODO: (CXSPA-6904) - Remove feature flag next major release -->
      <ng-container *cxFeature="'a11yFocusableCarouselControls'">
        <button
          *ngIf="i % size === 0"
          (click)="$event.stopPropagation(); activeSlide = i"
          [attr.aria-selected]="i === activeSlide"
          [attr.aria-disabled]="i === activeSlide"
          [attr.aria-label]="
            'carousel.slideNumber'
              | cxTranslate
                : {
                    currentSlideNumber: getSlideNumber(size, i),
                    numberOfSlides: size,
                  }
          "
          [attr.title]="
            'carousel.slideNumber'
              | cxTranslate
                : {
                    currentSlideNumber: getSlideNumber(size, i),
                    numberOfSlides: size,
                  }
          "
          role="tab"
        >
          <cx-icon [type]="indicatorIcon" aria-hidden="true"></cx-icon>
        </button>
      </ng-container>
      <ng-container *cxFeature="'!a11yFocusableCarouselControls'">
        <button
          *ngIf="i % size === 0"
          (click)="$event.stopPropagation(); activeSlide = i"
          [disabled]="i === activeSlide"
          [attr.aria-current]="i === activeSlide"
          [attr.aria-label]="
            'carousel.slideNumber'
              | cxTranslate
                : {
                    currentSlideNumber: getSlideNumber(size, i),
                    numberOfSlides: size,
                  }
          "
          [attr.title]="
            'carousel.slideNumber'
              | cxTranslate: { currentSlideNumber: getSlideNumber(size, i) }
          "
          tabindex="-1"
        >
          <cx-icon [type]="indicatorIcon" aria-hidden="true"></cx-icon>
        </button>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
